/**
 * 優先募集エリアナビ：該当セクションへスクロール
 */
function initAgencyAreaNavScroll() {
  const nav = document.querySelector('.p-agency-onboarding__area-nav');
  if (!nav) return;

  const buttons = nav.querySelectorAll('.p-agency-onboarding__area-nav-btn[data-scroll-target]');
  if (!buttons.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scrollToPanel = (selector) => {
    const target = document.querySelector(selector);
    if (!target) return;

    const targetId = selector;

    if (prefersReducedMotion) {
      const header = document.querySelector('.js-header');
      const offset = header ? header.offsetHeight : 0;
      const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
      window.scrollTo(0, top);
      return;
    }

    if (typeof smoothScrollTo === 'function') {
      smoothScrollTo(targetId, 500);
      return;
    }

    const header = document.querySelector('.js-header');
    const offset = header ? header.offsetHeight : 0;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    window.scrollTo({ top, behavior: 'smooth' });
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetSelector = button.getAttribute('data-scroll-target');
      if (!targetSelector) return;
      scrollToPanel(targetSelector);
    });
  });
}

// /**
//  * 代理店エントリーフォーム：必須項目のバリデーションと送信ボタン制御
//  */
// function initAgencyEntryForm() {
//   const form = document.querySelector('.p-agency-entry__form');
//   if (!form) return;

//   const submitBtn = form.querySelector('.p-agency-entry__submit-btn');
//   if (!submitBtn) return;

//   const MESSAGE_REQUIRED = '入力してください';
//   const MESSAGE_FORMAT = '形式が違います';

//   const formatValidators = {
//     'entry-zip': (value) => /^\d{3}-?\d{4}$/.test(value.trim()),
//     'entry-tel': (value) => {
//       const normalized = value.replace(/[━.‐.―.－.-.ー.-]/gi, '');
//       return /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(normalized);
//     },
//     'entry-email': (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()),
//   };

//   form.setAttribute('novalidate', '');

//   const fields = form.querySelectorAll('[required]');
//   const touchedFields = new WeakSet();

//   const getFieldErrorClass = (field) => {
//     if (field.classList.contains('p-agency-entry__textarea')) {
//       return 'p-agency-entry__textarea--error';
//     }

//     return 'p-agency-entry__input--error';
//   };

//   const hideFieldError = (field, errorEl) => {
//     errorEl.hidden = true;
//     errorEl.textContent = '';
//     field.classList.remove(getFieldErrorClass(field));
//     field.removeAttribute('aria-invalid');
//     field.removeAttribute('aria-describedby');
//   };

//   const showFieldError = (field, errorEl, message) => {
//     errorEl.textContent = message;
//     errorEl.hidden = false;
//     field.classList.add(getFieldErrorClass(field));
//     field.setAttribute('aria-invalid', 'true');
//     field.setAttribute('aria-describedby', errorEl.id);
//   };

//   const validateField = (field, errorEl, showMessage) => {
//     const value = field.value.trim();
//     const formatValidator = formatValidators[field.id];

//     if (value === '') {
//       if (showMessage) {
//         showFieldError(field, errorEl, MESSAGE_REQUIRED);
//       }

//       return false;
//     }

//     if (formatValidator && !formatValidator(field.value)) {
//       if (showMessage) {
//         showFieldError(field, errorEl, MESSAGE_FORMAT);
//       }

//       return false;
//     }

//     if (showMessage) {
//       hideFieldError(field, errorEl);
//     }

//     return true;
//   };

//   const fieldErrors = new Map();

//   fields.forEach((field) => {
//     const errorEl = document.createElement('p');
//     errorEl.className = 'p-agency-entry__error';
//     errorEl.id = `${field.id}-error`;
//     errorEl.setAttribute('role', 'alert');
//     errorEl.hidden = true;
//     field.insertAdjacentElement('afterend', errorEl);
//     fieldErrors.set(field, errorEl);

//     field.addEventListener('blur', () => {
//       touchedFields.add(field);
//       validateField(field, errorEl, true);
//       updateSubmitState();
//     });

//     field.addEventListener('input', () => {
//       if (touchedFields.has(field)) {
//         validateField(field, errorEl, true);
//       }

//       updateSubmitState();
//     });
//   });

//   const isFormValid = () => {
//     return Array.from(fields).every((field) => {
//       return validateField(field, fieldErrors.get(field), false);
//     });
//   };

//   const updateSubmitState = () => {
//     submitBtn.disabled = !isFormValid();
//   };

//   form.addEventListener('submit', (event) => {
//     if (isFormValid()) return;

//     event.preventDefault();

//     fields.forEach((field) => {
//       touchedFields.add(field);
//       validateField(field, fieldErrors.get(field), true);
//     });
//   });

//   updateSubmitState();
// }

// /**
//  * 相談会フォーム：必須項目のバリデーションと送信ボタン制御
//  */
// function initContactConsultationForm() {
//   const form = document.querySelector('.p-contact-consultation__form');
//   if (!form) return;

//   const submitBtn = form.querySelector('.p-contact-consultation__submit-btn');
//   if (!submitBtn) return;

//   const MESSAGE_REQUIRED = '入力してください';
//   const MESSAGE_FORMAT = '形式が違います';

//   const formatValidators = {
//     'consultation-tel': (value) => {
//       const normalized = value.replace(/[━.‐.―.－.-.ー.-]/gi, '');
//       return /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(normalized);
//     },
//     'consultation-email': (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()),
//   };

//   form.setAttribute('novalidate', '');
//   const fields = form.querySelectorAll('[required]');
//   const touchedFields = new WeakSet();
//   const fieldErrors = new Map();

//   const hideFieldError = (field, errorEl) => {
//     errorEl.hidden = true;
//     errorEl.textContent = '';
//     field.classList.remove('p-contact-consultation__input--error');
//     field.removeAttribute('aria-invalid');
//     field.removeAttribute('aria-describedby');
//   };

//   const showFieldError = (field, errorEl, message) => {
//     errorEl.textContent = message;
//     errorEl.hidden = false;
//     field.classList.add('p-contact-consultation__input--error');
//     field.setAttribute('aria-invalid', 'true');
//     field.setAttribute('aria-describedby', errorEl.id);
//   };

//   const validateField = (field, errorEl, showMessage) => {
//     const value = field.value.trim();
//     const formatValidator = formatValidators[field.id];

//     if (value === '') {
//       if (showMessage) {
//         showFieldError(field, errorEl, MESSAGE_REQUIRED);
//       }
//       return false;
//     }

//     if (formatValidator && !formatValidator(field.value)) {
//       if (showMessage) {
//         showFieldError(field, errorEl, MESSAGE_FORMAT);
//       }
//       return false;
//     }

//     if (showMessage) {
//       hideFieldError(field, errorEl);
//     }
//     return true;
//   };

//   const isFormValid = () => {
//     return Array.from(fields).every((field) => {
//       return validateField(field, fieldErrors.get(field), false);
//     });
//   };

//   const updateSubmitState = () => {
//     submitBtn.disabled = !isFormValid();
//   };

//   fields.forEach((field) => {
//     const errorEl = document.createElement('p');
//     errorEl.className = 'p-contact-consultation__error';
//     errorEl.id = `${field.id}-error`;
//     errorEl.setAttribute('role', 'alert');
//     errorEl.hidden = true;
//     field.insertAdjacentElement('afterend', errorEl);
//     fieldErrors.set(field, errorEl);

//     field.addEventListener('blur', () => {
//       touchedFields.add(field);
//       validateField(field, errorEl, true);
//       updateSubmitState();
//     });

//     field.addEventListener('input', () => {
//       if (touchedFields.has(field)) {
//         validateField(field, errorEl, true);
//       }
//       updateSubmitState();
//     });
//   });

//   form.addEventListener('submit', (event) => {
//     if (isFormValid()) return;
//     event.preventDefault();

//     fields.forEach((field) => {
//       touchedFields.add(field);
//       validateField(field, fieldErrors.get(field), true);
//     });
//   });

//   updateSubmitState();
// }

// /**
//  * なんでも問い合わせフォーム：必須項目のバリデーションと送信ボタン制御
//  */
// function initContactInquiryForm() {
//   const form = document.querySelector('.p-contact-inquiry__form');
//   if (!form) return;

//   const submitBtn = form.querySelector('.p-contact-inquiry__submit-btn');
//   if (!submitBtn) return;

//   const MESSAGE_REQUIRED = '入力してください';
//   const MESSAGE_FORMAT = '形式が違います';

//   const formatValidators = {
//     'inquiry-kana': (value) => /^([ァ-ン　 ]|ー)+$/.test(value.trim()),
//     'inquiry-zip': (value) => /^\d{3}-?\d{4}$/.test(value.trim()),
//     'inquiry-tel': (value) => {
//       const normalized = value.replace(/[━.‐.―.－.-.ー.-]/gi, '');
//       return /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(normalized);
//     },
//     'inquiry-email': (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()),
//   };

//   form.setAttribute('novalidate', '');

//   const fields = form.querySelectorAll('[required]');
//   const touchedFields = new WeakSet();
//   const fieldErrors = new Map();

//   const isRadioField = (field) => field.type === 'radio';

//   const shouldPlaceErrorInItemBody = (field) => {
//     const itemBody = field.closest('.p-contact-inquiry__item-body');

//     if (!itemBody) return false;

//     return (
//       isRadioField(field) ||
//       itemBody.classList.contains('p-contact-inquiry__item-body--family') ||
//       itemBody.classList.contains('p-contact-inquiry__item-body--age')
//     );
//   };

//   const getFieldGroup = (field) => {
//     if (isRadioField(field)) {
//       return field.closest('.p-contact-inquiry__radio-group');
//     }

//     return field;
//   };

//   const insertErrorElement = (field, errorEl) => {
//     if (shouldPlaceErrorInItemBody(field)) {
//       field.closest('.p-contact-inquiry__item-body').appendChild(errorEl);
//       return;
//     }

//     field.insertAdjacentElement('afterend', errorEl);
//   };

//   const getFieldErrorClass = (field) => {
//     if (field.classList.contains('p-contact-inquiry__select')) {
//       return 'p-contact-inquiry__select--error';
//     }

//     if (field.classList.contains('p-contact-inquiry__textarea')) {
//       return 'p-contact-inquiry__textarea--error';
//     }

//     if (isRadioField(field)) {
//       return 'p-contact-inquiry__radio-group--error';
//     }

//     return 'p-contact-inquiry__input--error';
//   };

//   const hideFieldError = (field, errorEl) => {
//     const target = getFieldGroup(field);

//     errorEl.hidden = true;
//     errorEl.textContent = '';
//     target.classList.remove(getFieldErrorClass(field));

//     if (!isRadioField(field)) {
//       field.removeAttribute('aria-invalid');
//       field.removeAttribute('aria-describedby');
//     }
//   };

//   const showFieldError = (field, errorEl, message) => {
//     const target = getFieldGroup(field);

//     errorEl.textContent = message;
//     errorEl.hidden = false;
//     target.classList.add(getFieldErrorClass(field));

//     if (!isRadioField(field)) {
//       field.setAttribute('aria-invalid', 'true');
//       field.setAttribute('aria-describedby', errorEl.id);
//     }
//   };

//   const getFieldValue = (field) => {
//     if (isRadioField(field)) {
//       const checked = form.querySelector(`input[name="${field.name}"]:checked`);
//       return checked ? checked.value : '';
//     }

//     return field.value.trim();
//   };

//   const validateField = (field, errorEl, showMessage) => {
//     const value = getFieldValue(field);
//     const formatValidator = formatValidators[field.id];

//     if (value === '') {
//       if (showMessage) {
//         showFieldError(field, errorEl, MESSAGE_REQUIRED);
//       }

//       return false;
//     }

//     if (formatValidator && !formatValidator(field.value)) {
//       if (showMessage) {
//         showFieldError(field, errorEl, MESSAGE_FORMAT);
//       }

//       return false;
//     }

//     if (showMessage) {
//       hideFieldError(field, errorEl);
//     }

//     return true;
//   };

//   const isFormValid = () => {
//     return Array.from(fields).every((field) => {
//       return validateField(field, fieldErrors.get(field), false);
//     });
//   };

//   const updateSubmitState = () => {
//     submitBtn.disabled = !isFormValid();
//   };

//   const processedRadioNames = new Set();

//   fields.forEach((field) => {
//     if (isRadioField(field)) {
//       if (processedRadioNames.has(field.name)) return;
//       processedRadioNames.add(field.name);
//     }

//     const errorEl = document.createElement('p');
//     errorEl.className = 'p-contact-inquiry__error';
//     errorEl.id = `${field.id || field.name}-error`;
//     errorEl.setAttribute('role', 'alert');
//     errorEl.hidden = true;

//     insertErrorElement(field, errorEl);
//     fieldErrors.set(field, errorEl);

//     const handleValidate = () => {
//       if (touchedFields.has(field)) {
//         validateField(field, errorEl, true);
//       }

//       updateSubmitState();
//     };

//     field.addEventListener('blur', () => {
//       touchedFields.add(field);
//       validateField(field, errorEl, true);
//       updateSubmitState();
//     });

//     if (isRadioField(field)) {
//       const radios = form.querySelectorAll(`input[type="radio"][name="${field.name}"]`);

//       radios.forEach((radio) => {
//         radio.addEventListener('change', () => {
//           touchedFields.add(field);
//           validateField(field, errorEl, true);
//           updateSubmitState();
//         });
//       });
//       return;
//     }

//     if (field.tagName === 'SELECT') {
//       field.addEventListener('change', () => {
//         touchedFields.add(field);
//         validateField(field, errorEl, true);
//         updateSubmitState();
//       });
//       return;
//     }

//     field.addEventListener('input', handleValidate);
//   });

//   form.addEventListener('submit', (event) => {
//     if (isFormValid()) return;

//     event.preventDefault();

//     fields.forEach((field) => {
//       touchedFields.add(field);
//       validateField(field, fieldErrors.get(field), true);
//     });
//   });

//   updateSubmitState();
// }

/**
 * 代理店エントリー select：未選択はプレースホルダー色、選択後は入力文字色
 */
function initAgencyEntrySelectStyle() {
  const form = document.querySelector('.p-agency-entry__form');
  if (!form || form.dataset.agencySelectStyleInit === 'true') return;

  form.dataset.agencySelectStyleInit = 'true';

  const filledClass = 'p-agency-entry__select--filled';

  const syncSelect = (select) => {
    if (!select.classList.contains('p-agency-entry__select')) return;

    select.classList.toggle(filledClass, select.value !== '');
  };

  form.querySelectorAll('.p-agency-entry__select').forEach(syncSelect);

  form.addEventListener('change', (event) => {
    const target = event.target;

    if (target instanceof HTMLSelectElement && target.classList.contains('p-agency-entry__select')) {
      syncSelect(target);
    }
  });
}

document.addEventListener('DOMContentLoaded', initAgencyAreaNavScroll);
document.addEventListener('DOMContentLoaded', initAgencyEntrySelectStyle);
document.addEventListener('wpcf7domready', initAgencyEntrySelectStyle);
// document.addEventListener('DOMContentLoaded', initAgencyEntryForm);
// document.addEventListener('DOMContentLoaded', initContactConsultationForm);
// document.addEventListener('DOMContentLoaded', initContactInquiryForm);
